import createIcon from '../../createIcon';

/**
 * @component @name MarkunreadMailbox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxMFYxM0g4VjVIMTRWMUg2VjdINEMyLjkgNyAyIDcuOSAyIDlWMjFDMiAyMi4xIDIuOSAyMyA0IDIzSDIwQzIxLjEgMjMgMjIgMjIuMSAyMiAyMVY5QzIyIDcuOSAyMS4xIDcgMjAgN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkunreadMailbox = createIcon('MarkunreadMailbox', [
  [
    'path',
    {
      d: 'M20 7H10V13H8V5H14V1H6V7H4C2.9 7 2 7.9 2 9V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V9C22 7.9 21.1 7 20 7Z',
      key: 'r2oqe1',
    },
  ],
]);

export default MarkunreadMailbox;
